import md5 from 'md5';
import { loadScript } from '@ifeng/ui_base';

const getSkey = (title, url) => {
    const str = `Ifeng888${encodeURIComponent(title)}${encodeURIComponent(url)}`;
    const skey = md5(str);

    return skey.substr(2, 6).toLowerCase();
};

/**
 * url 预处理
 * @param { String } url
 */
const handleUrl = url => {
    if (!url) return;

    if (url.indexOf('http:') === 0) {
        return url.replace('http:', '');
    } else if (url.indexOf('https:') === 0) {
        return url.replace('https:', '');
    } else if (url.indexOf('/') === 0) {
        return `/${url}`;
    } else {
        return `//${url}`;
    }
};

/**
 * 解析广告信息，返回广告回调方法
 * @param { Object } ad
 */
const handleAd = async ad => {
    let callbackFn = null;

    try {
        if (ad.preload) {
            let list = [];
            let index = 0;

            if (typeof ad.preload === 'string') {
                list = [ad.preload];
            } else {
                list = ad.preload;
            }

            while (list.length > index) {
                const scriptUrl = list[index];

                console.log('load', scriptUrl);

                await loadScript(scriptUrl, { cache: false, reload: false });
                ++index;
            }
        }

        callbackFn = new Function(`return ${ad.callback}`)();
    } catch (error) {
        error.message = `AdError - ${error.message}`;

        console.error(error);
        console.error('AdError - AdData', ad);

        if (window && window.BJ_REPORT) window.BJ_REPORT.report(error, false, 'ad');
    }

    return callbackFn;
};

const format = fmt => {
    const o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12,
        'H+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        S: this.getMilliseconds(),
    };
    const week = {
        '0': '/u65e5',
        '1': '/u4e00',
        '2': '/u4e8c',
        '3': '/u4e09',
        '4': '/u56db',
        '5': '/u4e94',
        '6': '/u516d',
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, `${this.getFullYear()}`.substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
        const regexp = RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468';

        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? regexp : '') + week[`${this.getDay()}`]);
    }
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
        }
    }

    return fmt;
};

/**
 * 图文单页热门文章和精彩视频推广数据处理方法
 * @param {array} content 推广位数据
 * @param {array} data 模块数据
 */
const handleRecommendData = (content, data) => {
    let result = [];

    if (data) {
        content = content && content.length > 0 ? content : [];

        if (data.length < 4) {
            result = data.concat(content);
        } else if (data.length >= 4 && data.length <= 7) {
            result = [
                ...data.slice(0, 3),
                content[0] ? content[0] : data[3],
                data[4],
                content[1] ? content[1] : data[5],
                content[2] ? content[2] : data[6],
            ];
        } else if (data.length === 8) {
            result = [
                ...data.slice(0, 3),
                content[0] ? content[0] : data[3],
                data[4],
                content[1] ? content[1] : data[5],
                data[6],
                content[2] ? content[2] : data[7],
            ];
        } else if (data.length === 9) {
            result = [
                ...data.slice(0, 3),
                content[0] ? content[0] : data[3],
                data[4],
                content[1] ? content[1] : data[5],
                data[6],
                data[7],
                content[2] ? content[2] : data[8],
            ];
        } else if (data.length >= 10) {
            result = [
                ...data.slice(0, 3),
                content[0] ? content[0] : data[3],
                data[4],
                content[1] ? content[1] : data[5],
                data[6],
                data[7],
                content[2] ? content[2] : data[8],
                data[9],
            ];
        }
    }

    result = result.filter(item => item);

    for (const item of result) {
        if (!item) {
            const e = new Error();

            e.message += `result = ${JSON.stringify(result)}
             ==========
             content = ${JSON.stringify(content)} 
             ==========
             data = ${JSON.stringify(data)}`;

            if (window && window.BJ_REPORT) window.BJ_REPORT.report(e, false, 'data');
        }
    }

    return result;
};

/**
 * 判断是否为移动端
 */
const isMobile = () => {
    if (
        /Mobile/i.test(navigator.userAgent) ||
        /AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
        /IfengNewsEXP|IfengNews|MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(
            navigator.userAgent,
        )
    ) {
        return true;
    }

    return false;
};

export { getSkey, handleUrl, handleAd, format, handleRecommendData, isMobile };
